import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { AppDispatch, RootState } from "services/redux/store";
import { closeSideNav, openSideNav } from "services/redux/site";
import { useEffect, useState } from "react";
import { Avatar } from "@mui/material";

// icons
import { logo } from "utils/assets_exports/images";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded"; // back arrow
import ArrowLeftRoundedIcon from "@mui/icons-material/ArrowLeftRounded";
import SpaceDashboardRoundedIcon from "@mui/icons-material/SpaceDashboardRounded"; // dashboard
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"; // incidents
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded"; // community
import PersonRoundedIcon from "@mui/icons-material/PersonRounded"; // users
import FlagRoundedIcon from "@mui/icons-material/FlagRounded"; // report posts
import ReportOffRoundedIcon from "@mui/icons-material/ReportOffRounded"; // spam posts
// import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded"; // notifications
import SendRoundedIcon from "@mui/icons-material/SendRounded"; // notifications
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded"; // calendar
import TagRoundedIcon from "@mui/icons-material/TagRounded"; // hashtag
import BoltRoundedIcon from "@mui/icons-material/BoltRounded"; // activity
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded"; // log report
import useWindowSize from "utils/hooks/useWindowSize";

const SideNav = () => {
    const sideNavOpened = useSelector(
        (state: RootState) => state.site.sideNavOpened
    );
    const dispatch = useDispatch<AppDispatch>();

    const [openCommunities, setOpenCommunities] = useState(false);
    const [openUsers, setOpenUsers] = useState(false);

    useEffect(() => {
        if (!sideNavOpened) {
            setOpenCommunities(false);
            setOpenUsers(false);
        }
    }, [sideNavOpened]);

    useEffect(() => {
        if (openCommunities || openUsers) {
            dispatch(openSideNav());
        }
    }, [openCommunities, openUsers]);

    const location = useLocation().pathname;

    const [windowSize] = useWindowSize();
    useEffect(() => {
        if (windowSize <= 768) {
            dispatch(closeSideNav());
        }
    }, [location]);

    return (
        <>
            <div
                className={`sm-screen-overlay h-screen w-screen bg-momeento-400 ${sideNavOpened ? "open" : ""}`}
                onClick={() => dispatch(closeSideNav())}
            ></div>
            <div
                className={`${sideNavOpened ? "open" : ""} text-sm bg-white dark:bg-momeento-400 border-x border-slate-200 dark:border-momeento-200 side-nav h-screen  xl:h-full`}
            >
                {/* <div className=" px-2 py-2"> */}
                <div className="flex justify-between lg:justify-start items-center gap-3 px-4 py-4 text-slate-600 dark:text-slate-200">
                    <div className=" flex justify-start items-center gap-3">
                        <span>
                            <Avatar src={logo} />
                        </span>
                        <h2 className="side-nav-text text-md font-bold">
                            Momeento
                        </h2>
                    </div>
                    <div className="lg:hidden">
                        <ArrowBackIosNewRoundedIcon
                            className={`side-nav-text`}
                            onClick={() => dispatch(closeSideNav())}
                        />
                    </div>
                </div>
                {/* </div> */}
                <ul className="px-4 ">
                    {/* home */}
                    <li className="py-2">
                        <Link
                            to="/"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <SpaceDashboardRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Dashboard</span>
                        </Link>
                    </li>
                    {/* incidents */}
                    <li className="py-2">
                        <Link
                            to="/incidents"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <WarningAmberRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Incidents</span>
                        </Link>
                    </li>
                    {/* community */}
                    <li className="py-2">
                        <div
                            className={`flex justify-between items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 ${openCommunities && "bg-slate-100 dark:bg-momeento-300"} hover:bg-slate-100 dark:hover:bg-momeento-300 rounded cursor-pointer`}
                            onClick={() =>
                                setOpenCommunities(() => !openCommunities)
                            }
                        >
                            <div className="flex justify-start items-center gap-3">
                                <span>
                                    <PeopleAltRoundedIcon fontSize="small" />
                                </span>
                                <span className="side-nav-text">
                                    Communities
                                </span>
                            </div>
                            <ArrowLeftRoundedIcon
                                className={`side-nav-text ${openCommunities ? "rotate-90" : "rotate-270"}`}
                            />
                        </div>
                        <ul className={`ps-5 ${!openCommunities && "hidden"}`}>
                            <li>
                                <Link
                                    to="/communities"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PeopleAltRoundedIcon fontSize="small" />
                                    </span>
                                    <span>All</span>
                                    {/* <span>Communities</span> */}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/communities/block"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PeopleAltRoundedIcon fontSize="small" />
                                    </span>
                                    <span>Blocked</span>
                                    {/* <span>Blocked Communities</span> */}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/communities/delete"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PeopleAltRoundedIcon fontSize="small" />
                                    </span>
                                    {/* <span>Deleted Communities</span> */}
                                    <span>Deleted</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* users */}
                    <li className="py-2">
                        <div
                            className={`flex justify-between items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 ${openUsers && "bg-slate-100 dark:bg-momeento-300"} hover:bg-slate-100 dark:hover:bg-momeento-300 rounded cursor-pointer`}
                            onClick={() => setOpenUsers(() => !openUsers)}
                        >
                            <div className="flex justify-start items-center gap-3">
                                <span>
                                    <PersonRoundedIcon fontSize="small" />
                                </span>
                                <span className="side-nav-text">Users</span>
                            </div>
                            <ArrowLeftRoundedIcon
                                className={`side-nav-text ${openUsers ? "rotate-90" : "rotate-270"}`}
                            />
                        </div>
                        <ul className={`ps-5 ${!openUsers && "hidden"}`}>
                            <li>
                                <Link
                                    to="/users"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PersonRoundedIcon fontSize="small" />
                                    </span>
                                    {/* <span>Users</span> */}
                                    <span>All</span>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/users/block"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PersonRoundedIcon fontSize="small" />
                                    </span>
                                    {/* <span>Blocked Users</span> */}
                                    <span>Blocked</span>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/users/delete"
                                    className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                                >
                                    <span>
                                        <PersonRoundedIcon fontSize="small" />
                                    </span>
                                    {/* <span>Deleted Users</span> */}
                                    <span>Deleted </span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* report posts */}
                    <li className="py-2">
                        <Link
                            to="/report-posts"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <FlagRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Posts Reports</span>
                        </Link>
                    </li>
                    {/* spam posts */}
                    <li className="py-2">
                        <Link
                            to="/spam-posts"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <ReportOffRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Spam Posts</span>
                        </Link>
                    </li>
                    {/* notifications */}
                    <li className="py-2">
                        <Link
                            to="/notifications"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <SendRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">
                                Push Notifications
                            </span>
                        </Link>
                    </li>
                    {/* activity */}
                    <li className="py-2">
                        <Link
                            to="/activity"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <BoltRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Activity</span>
                        </Link>
                    </li>
                    {/* calendar */}
                    <li className="py-2">
                        <Link
                            to="/calendar"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <CalendarMonthRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Calendar</span>
                        </Link>
                    </li>
                    {/* Hashtag */}
                    <li className="py-2">
                        <Link
                            to="/hashtags"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <TagRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Hashtags</span>
                        </Link>
                    </li>
                    {/* log report */}
                    <li className="py-2">
                        <Link
                            to="/log-report"
                            className="nav-link flex justify-start items-center gap-3 px-2 py-2 text-slate-600 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-momeento-300 rounded"
                        >
                            <span>
                                <AssessmentRoundedIcon fontSize="small" />
                            </span>
                            <span className="side-nav-text">Log Report</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default SideNav;
